import React, { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";
import api from "@/lib/api";
import { brl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Copy, QrCode as QrIcon } from "lucide-react";
import { toast } from "sonner";

export default function PixQrCode({ amount, txid }) {
  const [payload, setPayload] = useState("");
  const [key, setKey] = useState("");
  const canvasRef = useRef(null);

  useEffect(() => {
    let alive = true;
    api.post("/pix/code", { amount: Number(amount) || 0, txid })
      .then(({ data }) => {
        if (!alive) return;
        setPayload(data.payload); setKey(data.key);
        if (canvasRef.current) {
          QRCode.toCanvas(canvasRef.current, data.payload, { width: 240, margin: 1,
            color: { dark: "#0F172A", light: "#FFFFFF" } }).catch(() => {});
        }
      })
      .catch(() => toast.error("Falha ao gerar PIX"));
    return () => { alive = false; };
  }, [amount, txid]);

  const copy = async () => {
    try { await navigator.clipboard.writeText(payload); toast.success("Código PIX copiado!"); }
    catch { toast.error("Não foi possível copiar"); }
  };

  return (
    <div className="flex flex-col items-center gap-3 py-2" data-testid="pix-qr-block">
      <div className="flex items-center gap-2 text-sm font-semibold">
        <QrIcon className="w-4 h-4 text-blue-600" /> Pague com PIX
      </div>
      <canvas ref={canvasRef} className="rounded-lg border border-slate-200" />
      <div className="text-center text-xs text-slate-500">
        <div><b>Chave PIX (CNPJ):</b> <span className="font-mono">{key || "29421612000130"}</span></div>
        <div className="mt-1 kpi-num text-lg text-slate-900">{brl(amount)}</div>
      </div>
      <Button variant="outline" size="sm" onClick={copy} data-testid="copy-pix-btn" className="w-full">
        <Copy className="w-3.5 h-3.5 mr-1.5" /> Copiar código PIX
      </Button>
    </div>
  );
}
